export interface IStripeStatusResponse {
  hasAccount: boolean;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  accountId?: string;
}

export interface IStripeLinkResponse {
  url: string;
}

export enum PaymentHoldApplyTo {
  ALL_PATIENTS = 'all_patients',
  NEW_PATIENTS = 'new_patients',
}

export interface IStripeCheckoutSettingRequest {
  isStripeCheckoutEnabled: boolean;
  bookingDepositAmount?: number;
  paymentHoldApplyTo?: PaymentHoldApplyTo;
  paymentHoldWithinDays?: number | null;
}

// Copied from BE
export enum PaymentStatus {
  HELD = 'held',
  CAPTURED = 'captured',
  RELEASED = 'released',
  REFUNDED = 'refunded',
  AUTH_EXPIRED = 'auth_expired',
  FAILED = 'failed',
  DISPUTED = 'disputed',
}

// Copied from BE
export enum PaymentFailedOperation {
  CAPTURE = 'capture',
  RELEASE = 'release',
  NO_SHOW_FEE = 'no_show_fee',
  REFUND = 'refund',
}

export interface IPaymentDispute {
  status: string | null;
  reason: string | null;
  evidenceDueBy: string | null;
}

export interface IPaymentAuthorization {
  appointmentId: string;
  bookingId: string;
  appointmentDate: string;
  startTime: string;
  timezone: string;
  patient: { firstName: string; lastName: string; name: string } | null;
  doctor: { id: string; name: string } | null;
  service: { id: string; name: string } | null;
  requestedAt: string;
  holdAmount: number | null;
  holdExpiresAt: string | null;
  status: PaymentStatus | null;
  isDisputed: boolean;
  dispute: IPaymentDispute | null;
  noShowFeeChargedAt: string | null;
  failedOperation: PaymentFailedOperation | null;
  stripeFailureReason: string | null;
}

export interface IPaymentAuthorizationListResponse {
  data: IPaymentAuthorization[];
  metadata: { total: number; limit?: number; page?: number };
}

export interface IPaymentAuthorizationStats {
  totalAuthsHeldAmount: number;
  activeHoldsCount: number;
  patientAuthsHeldCount: number;
  showsCount: number;
  noShowsCancelledCount: number;
  chargedAmount: number;
  upcomingHoldAuth: number;
}
